module.exports = "/next-static/_next/static/images/aiClips-ac4873eeaed2963faaa3f003d525e978.png";